import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatChipInputEvent } from '@angular/material/chips';
import { ENTER, COMMA } from '@angular/cdk/keycodes';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { APIService, ModelSortDirection } from 'src/app/API.service';

@Component({
  selector: 'app-assign-dialog',
  templateUrl: './assign-dialog.component.html',
  styleUrls: ['./assign-dialog.component.scss']
})
export class AssignDialogComponent implements OnInit {
  emailList: string[] = [];
  emailCtrl = new FormControl('');
  readonly separatorKeysCodes = [ENTER, COMMA];
  filteredEmails: Observable<string[]>;
  previousEmails: string[] = [];

  constructor(
    public dialogRef: MatDialogRef<AssignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { selectedCount: number, clientID: string },
    private api: APIService
  ) {
    this.filteredEmails = this.emailCtrl.valueChanges.pipe(
      startWith(null),
      map((email: string | null) => email ? this._filter(email) : this.previousEmails.slice())
    );
  }

  async ngOnInit() {
    try {
      const response = await this.api.ListInvoiceUserAssignmentsByClientID(this.data.clientID,undefined, ModelSortDirection.DESC);
      if (response?.items) {
        // Get unique emails
        this.previousEmails = [...new Set(
          response.items
            .filter((item): item is NonNullable<typeof item> => item !== null)
            .map(item => item.email)
            .filter((email): email is string => email !== null && email !== undefined)
        )];
      }
    } catch (error) {
      console.error('Error fetching email assignments:', error);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.previousEmails.filter(email => 
      email.toLowerCase().includes(filterValue) &&
      !this.emailList.includes(email)
    );
  }

  addEmail(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value && this.isValidEmail(value)) {
      this.emailList.push(value);
      event.chipInput!.clear();
      this.emailCtrl.setValue(null);

      // Add to previous emails if it's new
      if (!this.previousEmails.includes(value)) {
        this.previousEmails.push(value);
      }
    }
  }

  selected(email: string): void {
    if (!this.emailList.includes(email)) {
      this.emailList.push(email);
      this.emailCtrl.setValue(null);
    }
  }

  removeEmail(email: string): void {
    const index = this.emailList.indexOf(email);
    if (index >= 0) {
      this.emailList.splice(index, 1);
    }
  }

  onSubmit(): void {
    if (this.emailList.length > 0) {
      this.dialogRef.close(this.emailList);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  private isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }
} 